var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,47c0.55,0,1-0.45,1-1V26c0-0.55-0.45-1-1-1s-1,0.45-1,1v20C21,46.55,21.45,47,22,47z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30,47c0.55,0,1-0.45,1-1V26c0-0.55-0.45-1-1-1s-1,0.45-1,1v20C29,46.55,29.45,47,30,47z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38,47c0.55,0,1-0.45,1-1V26c0-0.55-0.45-1-1-1s-1,0.45-1,1v20C37,46.55,37.45,47,38,47z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18,54h24c2.76,0,5-2.24,5-5V20c1.65,0,3-1.35,3-3v-3c0-1.65-1.35-3-3-3H37V7c0-0.55-0.45-1-1-1H24c-0.55,0-1,0.45-1,1v4H13  c-1.65,0-3,1.35-3,3v3c0,1.65,1.35,3,3,3v29C13,51.76,15.24,54,18,54z M25,8h10v3H25V8z M12,17v-3c0-0.55,0.45-1,1-1h11h12h11  c0.55,0,1,0.45,1,1v3c0,0.55-0.45,1-1,1h-1H14h-1C12.45,18,12,17.55,12,17z M45,20v29c0,1.65-1.35,3-3,3H18c-1.65,0-3-1.35-3-3V20  H45z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8bb6b301.svg";
export { ForwardRef as ReactComponent };